import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AdminService } from '../../admin.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { QuickDesignService } from '../../../services/quick-deisgn.service';
import { QuickDesign } from '../../../models/quick-design.model';
import { Menu } from '../../../models/menu.model';

declare var jQuery: any;
declare const $: any;
@Component({
  selector: 'app-quick-designs',
  templateUrl: './quick-designs.component.html',
  styleUrls: ['./quick-designs.component.css']
})
export class QuickDesignsComponent implements OnInit, OnDestroy {
  loading = false;
  menus: Menu[] = [];
  subscription: Subscription;
  deleteSubscription: Subscription;
  quickDesigns: QuickDesign[];
  category: string;
  category_id: number;
  category_name = '';

  dataTableHtml: any;

  @ViewChild('previewModal') previewModal: ElementRef;

  categories = {
    'enewsletter': {
      id: 1,
      name: 'eMarketing'
    },
    'buyer-match': {
      id: 2,
      name: 'Buyer Match'
    },
    'quick-enquiry': {
      id: 3,
      name: 'Quick Enquiry'
    },
    'brochure': {
      id: 4,
      name: 'Brochure'
    },
    'property-guide': {
      id: 5,
      name: 'Property Guide'
    },
    'social-media': {
      id: 6,
      name: 'Social Media'
    },
    'email-signature': {
      id: 7,
      name: 'Email Signature'
    },
    'dl-card': {
      id: 8,
      name: 'DL Card'
    },
    'sign-board': {
      id: 9,
      name: 'Signboard'
    }
  };

  constructor(private adminService: AdminService,
    private quickDesignService: QuickDesignService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loading = true;
    this.menus = [
      new Menu('Elements', '', [
        new Menu('eMarketing', 'templates/elements/enewsletter'),
        new Menu('Buyer Match', 'templates/elements/buyer-match'),
        new Menu('Quick Enquiry',  'templates/elements/quick-enquiry'),
        new Menu('Brochure',  'templates/elements/brochure'),
        new Menu('Property Guide',  'templates/elements/property-guide'),
        new Menu('Social Media',  'templates/elements/social-media'),
        new Menu('Email Signature',  'templates/elements/email-signature'),
        new Menu('DL Card',  'templates/elements/dl-card'),
        new Menu('Signboard',  'templates/elements/sign-board')
      ]),
      new Menu('Quick Designs', '', [
        new Menu('eMarketing', 'templates/quick-designs/enewsletter'),
        new Menu('Buyer Match', 'templates/quick-designs/buyer-match'),
        new Menu('Quick Enquiry',  'templates/quick-designs/quick-enquiry'),
        new Menu('Brochure',  'templates/quick-designs/brochure'),
        new Menu('Property Guide',  'templates/quick-designs/property-guide'),
        new Menu('Social Media',  'templates/quick-designs/social-media'),
        new Menu('Email Signature',  'templates/quick-designs/email-signature'),
        new Menu('DL Card',  'templates/quick-designs/dl-card'),
        new Menu('Signboard',  'templates/quick-designs/sign-board')
      ]),
      new Menu('Masters', '', [
        new Menu('eMarketing', 'templates/masters/enewsletter'),
        new Menu('Buyer Match', 'templates/masters/buyer-match'),
        new Menu('Quick Enquiry',  'templates/masters/quick-enquiry'),
        new Menu('Brochure',  'templates/masters/brochure'),
        new Menu('Property Guide',  'templates/masters/property-guide'),
        new Menu('Social Media',  'templates/masters/social-media'),
        new Menu('Email Signature',  'templates/masters/email-signature'),
        new Menu('DL Card',  'templates/masters/dl-card'),
        new Menu('Signboard',  'templates/masters/sign-board')
      ])
    ];

    this.adminService.fullPageContent = false;
    this.adminService.loadMenu(this.menus);

    this.route.params.subscribe(
      (params: Params) => {
        this.loading = true;
        this.category = params['type'];
        this.category_id = this.categories[this.category].id;
        this.category_name = this.categories[this.category].name;

        this.quickDesignService.httpGetQuickDesigns(
          {
            category_id: this.category_id
          },
          'dashboard'
        );
      }
    );

    this.subscription = this.quickDesignService.quickDesignsChanged.subscribe(
      (quickDesigns: any) => {
        if (typeof quickDesigns !== 'undefined' &&
            typeof quickDesigns.status !== 'undefined' &&
              quickDesigns.status === 'success' ) {
          this.loading = false;
          this.quickDesigns = quickDesigns.data;

          if ($.fn.DataTable.isDataTable(this.dataTableHtml)) {
            this.dataTableHtml.destroy();
          }
          this.initDT();
        }
      }
    );

    this.deleteSubscription = this.quickDesignService.quickDesignDelete.subscribe(
      (quickDesign: any) => {
        if (typeof quickDesign !== 'undefined' && quickDesign.status === 'success' ) {
                this.loading = false;
                this.quickDesignService.httpGetQuickDesigns(
                  {
                    category_id: this.category_id
                  },
                  'dashboard'
                );
            }
      }
    );
  }

  initDT() {
    setTimeout(() => {
      this.dataTableHtml = $('#datatable-quick-designs').DataTable({
        'pagingType': 'full_numbers',
        'lengthMenu': [
          [50, 100, 200, -1],
          [50, 100, 200, 'All']
        ],
        'pageLength': 50,
        // responsive: true,
        stateSave: true,
        language: {
          search: '_INPUT_',
          searchPlaceholder: 'Search',
          'paginate': {
            'first': '<i aria-hidden="true" class="fa fa-angle-double-left"></i>',
            'previous': '<i aria-hidden="true" class="fa fa-angle-left"></i>',
            'next': '<i aria-hidden="true" class="fa fa-angle-right"></i>',
            'last': '<i aria-hidden="true" class="fa fa-angle-double-right"></i>'
          }
        },
        'fnDrawCallback': function (oSettings) {
          $('.dataTables_wrapper').find('input[type=search]').addClass('btn-search');
          $('.dataTables_wrapper').find('select').addClass('select_datatable');
        }
      });

    }, 500);
  }

  onPreview($id: number) {
    this.previewModal.nativeElement.querySelector('.modal-body img').src
      = this.adminService.appConfig.S3_URL + 'quick-designs/thumbnails/' + $id + '.jpg';
  }

  onDelete(id: number) {
    this.loading = true;
    this.quickDesignService.httpDeleteQuickDesign(id);
  }

  ngOnDestroy() {
    this.adminService.authService.cancelRequest();
    this.subscription.unsubscribe();
    this.deleteSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/quick-designs/quick-designs.component.ts